package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.BookmarkW500Rounded: ImageVector
    get() {
        if (_bookmarkW500Rounded != null) {
            return _bookmarkW500Rounded!!
        }
        _bookmarkW500Rounded = Builder(name = "BookmarkW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveToRelative(480.0f, 728.85f)
                lineToRelative(-161.07f, 68.89f)
                quadToRelative(-45.5f, 19.15f, -86.28f, -7.6f)
                quadToRelative(-40.78f, -26.74f, -40.78f, -75.68f)
                verticalLineToRelative(-511.59f)
                quadToRelative(0.0f, -37.78f, 26.61f, -64.39f)
                reflectiveQuadToRelative(64.39f, -26.61f)
                horizontalLineToRelative(394.26f)
                quadToRelative(37.78f, 0.0f, 64.39f, 26.61f)
                reflectiveQuadToRelative(26.61f, 64.39f)
                verticalLineToRelative(511.59f)
                quadToRelative(0.0f, 48.94f, -40.78f, 75.68f)
                quadToRelative(-40.78f, 26.75f, -86.28f, 7.6f)
                lineTo(480.0f, 728.85f)
                close()
                moveTo(480.0f, 629.13f)
                lineTo(677.13f, 713.7f)
                verticalLineToRelative(-510.83f)
                lineTo(282.87f, 202.87f)
                verticalLineToRelative(510.83f)
                lineTo(480.0f, 629.13f)
                close()
                moveTo(480.0f, 202.87f)
                lineTo(282.87f, 202.87f)
                horizontalLineToRelative(394.26f)
                lineTo(480.0f, 202.87f)
                close()
            }
        }
        .build()
        return _bookmarkW500Rounded!!
    }

private var _bookmarkW500Rounded: ImageVector? = null
